import React from 'react';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

/**
 * Single-series area/line trend — month-over-month / week-over-week totals
 * (Production Incident, Support Bugs, EPD Bugs, MTTR, Defect Leakage Ratio).
 */
function SimpleTrendChart({ data, dimensionKey, valueKey, color = 'var(--cmp-primary)', height = 160, valueSuffix = '' }) {
  return (
    <ResponsiveContainer width="100%" height={height}>
      <AreaChart data={data} margin={{ top: 10, right: 20, left: 0, bottom: 5 }}>
        <CartesianGrid strokeDasharray="3 3" vertical={false} />
        <XAxis dataKey={dimensionKey} tick={{ fontSize: 11 }} />
        <YAxis tick={{ fontSize: 11 }} />
        <Tooltip formatter={(v) => `${v}${valueSuffix}`} />
        <Area type="monotone" dataKey={valueKey} stroke={color} fill={color} fillOpacity={0.15} strokeWidth={2} dot={{ r: 3 }} />
      </AreaChart>
    </ResponsiveContainer>
  );
}

export default SimpleTrendChart;
